import React from 'react'
import PropTypes from 'prop-types'
import { compose } from 'recompose'
import { lpForm } from 'lp-form'
import { Field, FormSection, propTypes as formPropTypes } from 'redux-form'
import { Input, SubmitButton } from 'lp-components'

const propTypes = {
  ...formPropTypes,
  hideSubmit: PropTypes.bool,
}

const defaultProps = {
  hideSubmit: false,
}

function ArtsLiaisonForm({
  handleSubmit,
  submitSucceeded,
  pristine,
  submitting,
  hideSubmit,
}) {
  return (
    <form onSubmit={handleSubmit} noValidate id="school-arts-liaison">
      <FormSection name="contacts">
        <span className="row">
          <Field
            className="col-3"
            name="firstName"
            component={Input}
            autoComplete="given-name"
          />
          <Field
            className="col-3"
            name="lastName"
            component={Input}
            autoComplete="family-name"
          />
          <Field
            className="col-2"
            name="phone"
            type="tel"
            component={Input}
            autoComplete="tel"
          />
          <Field
            className="col-3"
            name="email"
            type="email"
            component={Input}
            autoComplete="email"
          />
        </span>
      </FormSection>
      {!hideSubmit && (
        <div className="button-wrapper">
          <SubmitButton
            {...{ pristine: submitSucceeded && pristine, submitting }}
          >
            Save Response
          </SubmitButton>
        </div>
      )}
    </form>
  )
}
ArtsLiaisonForm.propTypes = propTypes
ArtsLiaisonForm.defaultProps = defaultProps

export default compose(
  lpForm({
    name: 'school-arts-liason',
    enableReinitialize: true,
    constraints: {
      'contacts.firstName': {
        presence: true,
      },
      'contacts.lastName': {
        presence: true,
      },
      'contacts.phone': {
        presence: true,
        format: {
          pattern: /^\(?([0-9]{3})\)?[-. ]?([0-9]{3})[-. ]?([0-9]{4})$/,
          message: 'must be a valid phone number',
        },
      },
      'contacts.email': { presence: true, email: true },
    },
  })
)(ArtsLiaisonForm)
